export default {
  wrapper: {
    margin: [0, 'auto', 40],
  },
  tableBlock: {
    marginTop: 20,
  },
  buttonsWrapper: {
    float: 'right',
    display: 'flex',
    alignItems: 'center',
  },
  excelButton: {
    marginLeft: 15,
    height: 'fit-content',
  },
  inputLast: {
    marginLeft: 8,
  },
};
